export default {
  EXPAND_STEP: 'EXPAND_STEP',
  REMOVE_AUTH_TOKEN: 'REMOVE_AUTH_TOKEN',
  SET_AUTH_TOKEN: 'SET_AUTH_TOKEN',
  SET_CONTACT_INFO: 'SET_CONTACT_INFO',
  SET_ENROLLMENT: 'SET_ENROLLMENT',
  SET_PARTIAL_STEP_DATA: 'SET_PARTIAL_STEP_DATA',
  SET_POSTULANT_EMAIL: 'SET_POSTULANT_EMAIL',
  SET_POSTULANT_RUT: 'SET_POSTULANT_RUT',
  SET_HAS_ACCEPTED_TERMS: 'SET_HAS_ACCEPTED_TERMS',
  SET_STEP_DATA: 'SET_STEP_DATA',
  SET_STEP_INDEX: 'SET_STEP_INDEX',
  SET_STEP_ENROLLMENT_LEGAL_INDEX: 'SET_STEP_ENROLLMENT_LEGAL_INDEX',
  SET_TRACKING_NUMBER: 'SET_TRACKING_NUMBER',
  SHRINK_STEP: 'SHRINK_STEP',
  GO_TO_VIEW: 'GO_TO_VIEW',
  ACCEPT_LEGAL_BACKGROUND_INSTRUCTIONS: 'ACCEPT_LEGAL_BACKGROUND_INSTRUCTIONS',
  ACCEPT_UAF_INSTRUCTIONS: 'ACCEPT_UAF_INSTRUCTIONS',
};

// COMENTARIO
